import client, { phpClient } from './client';

/**
 * 前台提交申请的参数
 */
export interface SubmitApplicationParams {
  job_id?: number | string;
  job_key: string;
  job_title: string;
  candidate_name: string;
  candidate_email: string;
  candidate_mobile?: string;
  resume_file_id?: string;
  resume_url?: string;  // 简历完整 URL
  [key: string]: any;
}

/**
 * 上传简历响应（拦截器已解包 data 字段）
 */
export interface UploadResumeResponse {
  file_id: string;
  url: string;
  [key: string]: any;
}

/**
 * 上传简历到 OSS (PHP 服务)
 */
export const uploadResume = (file: File): Promise<UploadResumeResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  return phpClient.post('/upload/resume', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

/**
 * 提交职位申请 - 双写
 * 1. 主写入：PHP 服务（原有逻辑，必须成功）
 * 2. 副写入：Node 服务（异步，失败不影响主流程）
 */
export const submitApplication = async (data: SubmitApplicationParams) => {
  // 1. 主写入 - PHP 服务（原有投递逻辑）
  const result = await phpClient.post('/application/submit', data);

  // 2. 副写入 - Node 服务（异步双写到 SQLite）
  // 转换字段格式适配 Node API
  const nodeData = {
    jobId: data.job_key || String(data.job_id),
    fullName: data.candidate_name,
    email: data.candidate_email,
    phone: data.candidate_mobile || '',
    resumeUrl: data.resume_url || null,  // 使用完整 URL
  };

  // 异步写入，不阻塞主流程，失败只打日志
  client.post('/applications', nodeData).catch((err) => {
    console.warn('双写到 Node 服务失败:', err.message);
  });

  return result;
};
